import { ChangeDetectionStrategy, Component, inject, Injector } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { RenderDirective } from '@core/prosemirror-legacy/angular';
import {
  ProsemirrorBasicConfig,
  ProsemirrorBasicConfigDirective,
} from '@core/prosemirror-legacy/webapp';
import { SymbolComponent } from '@core/symbol-legacy';
import {
  DialogBodyComponent,
  DialogComponent,
  DialogHeaderComponent,
  HeadingComponent,
  IconContainerComponent,
} from '@core/user-interface-legacy';
import { AskTemplatesDataService } from '@tellent-ask-hr/templates-logic';

import { AskTemplatesDialogService } from '../ask-templates-dialog.service';

@Component({
  selector: 'add-new-template',
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    HeadingComponent,
    TranslatePipe,
    SymbolComponent,
    ProsemirrorBasicConfigDirective,
    RenderDirective,
    IconContainerComponent,
  ],
  templateUrl: './add-new-template.component.html',
  styleUrl: './add-new-template.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddNewTemplateComponent extends DialogComponent<void, void> {
  private readonly injector = inject(Injector);
  private readonly templatesDataService = inject(AskTemplatesDataService);
  private readonly askTemplatesDialogService = inject(AskTemplatesDialogService);

  protected readonly ProsemirrorBasicConfig = ProsemirrorBasicConfig;

  protected predefinedTemplates = this.templatesDataService.predefinedTemplates;

  public ngOnInit(): void {
    this.templatesDataService.loadPredefinedTemplates();
  }

  protected onAddCustom() {
    this.dialogRef.close();
    this.askTemplatesDialogService.openCreateTemplateDialog(this.injector);
  }
}
